import ModalView from 'common-views/ModalView';
import template  from 'dashboard/forms/modal/migrate-connection.ejs';
import constants from 'Constants';

class MigrateConnectionModal extends ModalView {
    
    initialize(){
        super.initialize();
        this.template = template;
        this.selectedMigration = "import"; //Set import as default
        this.isWarning = this.model.get("warning");
    }

    bindEvents(){      
        $(`${constants.DIALOG_ID} input.action-selector`).on("click", (e)=>{
            const newVal = e.currentTarget.value;
            this.selectedMigration = newVal;
        });
    }

    render(){
        return new Promise((resolve, reject) => {
            const settings = this.settings;

            settings.buttons = [
                {
                    text:  this.isWarning ? 'Yes' : 'Ok',
                    click: () => {
                        resolve(this.selectedMigration);
                        this.closeModal();
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        reject();
                        this.closeModal();
                    }
                }
            ];

            if(this.isWarning){
                settings.buttons.splice(1, 0, {
                    text: 'No',
                    click: () => {
                        resolve("noBackup");
                        this.closeModal();
                    }
                })
            }

            settings.open = () => {
                this.bindEvents();
                $(`input.action-selector[value='${this.selectedMigration}']`).prop("checked", true); //Set import as default
            };

            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render();

        });
    }
}
export default MigrateConnectionModal;